export default "__VITE_ASSET__CBzTFgmk__"